import { render, staticRenderFns } from "./employee_details.vue?vue&type=template&id=081ef7c6&scoped=true&"
import script from "./employee_details.vue?vue&type=script&lang=js&"
export * from "./employee_details.vue?vue&type=script&lang=js&"
import style0 from "./employee_details.vue?vue&type=style&index=0&id=081ef7c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081ef7c6",
  null
  
)

export default component.exports